import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Drawer from '@blade/common/components/task-management/paint.vue';
import map from '@blade/common-ui/map-old/2d/src/components/drawer-map/index.vue';
import { fetchMapDetail } from '@blade/common-ui/map-old/2d/src/api/index';
import { cloneDeep, isEmpty } from 'lodash';
import { MapPolygonsModule } from '@blade-sxp/task-management/store/mapPolygons';
import mapUtil from '@blade-sxp/map/components/index.vue';
import MapDeviceIcon from '@blade-sxp/map-management/pages/2d/components/map/device.vue';
const Service = { fetchMapDetail };
// interface Icrowd {
//   mapId:string;
//   roi:Atlas
// }
let MapDarwer = class MapDarwer extends Vue {
    zoneId;
    dataSource;
    buttons;
    showSelect;
    limits;
    isPlayFlag;
    directionConfig;
    specifiedStyle;
    paintState;
    options;
    styleProp;
    // @Prop() readonly mapSource!:Icrowd[];
    index;
    videoPolygons;
    mapId;
    showPoints;
    loading = true;
    backgroundURL = '';
    zoneListLinked = [];
    localpaintState = true;
    roiListData = [];
    deviceList = [];
    mapType = '';
    get removeKey() {
        return MapPolygonsModule.reoveKey;
    }
    get mapSource() {
        return MapPolygonsModule.mapPolygonMap;
    }
    get currentDeviceId() {
        return MapPolygonsModule.currentDeviceId;
    }
    onchangeKey(val) {
        this.setRoiList();
    }
    onChangeMapSource(val) {
        if (!isEmpty(val)) {
            this.setRoiList();
        }
    }
    get setBoxStyle() {
        return {
            width: `${this.styleProp.width}px`,
            height: `${this.styleProp.height}px`,
        };
    }
    formatPolygons(val) {
        const dom = document.querySelector('.dialog-content-left');
        const mapDom = this.$refs.mapEnd;
        const rectInfor = dom.getBoundingClientRect();
        const offSetLeft = rectInfor.left;
        const offSetTop = rectInfor.top;
        const h = this.styleProp.height;
        const w = this.styleProp.width;
        let mapPolygons = [];
        if (!isEmpty(val) && w && h) {
            cloneDeep(val).forEach(item => {
                mapPolygons = item.vertices.map(item => {
                    const { relativePosition } = mapDom.clientToMapPosition(Number(item.x) * w + offSetLeft, Number(item.y) * h + offSetTop);
                    return {
                        x: relativePosition.x,
                        y: relativePosition.y,
                        z: 0
                    };
                });
            });
        }
        return mapPolygons;
    }
    getMapdrawend(val) {
        if (val && val.length) {
            const mapLen = val[0].vertices.length;
            const videoLen = this.videoPolygons[this.index].vertices.length;
            const id = val[0].id;
            if (mapLen !== videoLen && id) {
                this.$message.error(this.$t('mapRoiError').toString());
                const darwerDom = this.$refs.simpleDrawer;
                this.$nextTick(() => {
                    darwerDom.deleteGraph(id);
                    this.$emit('map-drawend', { status: false });
                });
            }
            else {
                const roi = this.formatPolygons(val);
                const data = {
                    vertices: roi,
                    mapId: this.mapId,
                    title: `ROI-${this.index + 1}`
                };
                MapPolygonsModule.updataMapPolygonMap(data);
                this.setRoiList();
                this.$message({
                    message: `ROI-${this.index + 1} complete`,
                    type: 'success'
                });
                this.$emit('map-drawend', { status: true, value: val });
                const darwerDom = this.$refs.simpleDrawer;
                this.$nextTick(() => {
                    darwerDom.deleteGraph(id);
                });
            }
        }
    }
    onChangeZoneId(val) {
        if (val) {
            this.getMapInformation(val);
        }
    }
    setRoiList() {
        const mapData = this.mapSource;
        let roiData = [];
        mapData.forEach((item) => {
            roiData.push(item);
        });
        this.roiListData = roiData;
    }
    getMapInformation(zoneId) {
        this.loading = true;
        Service.fetchMapDetail({
            zoneId: zoneId,
            checkZoneTaskAlive: false,
            bizTaskTypeEnum: '',
            externalBizFrom: '',
        }).then((res) => {
            if (res) {
                let deviceListData = [];
                this.backgroundURL = res?.mapImageUrl;
                this.mapType = res?.mapType;
                res?.deviceList?.forEach((item) => {
                    if (this.currentDeviceId && item?.id === this.currentDeviceId) {
                        let device = {
                            id: item?.id,
                            status: item?.status,
                            vertices: item?.vertices,
                            vueConfig: {
                                instance: MapDeviceIcon,
                                data: {
                                    status: item?.status,
                                    deviceId: item?.id
                                }
                            }
                        };
                        deviceListData.push(device);
                    }
                });
                this.deviceList = deviceListData;
            }
        }).finally(() => {
            this.loading = false;
        });
    }
    get mouseBgClass() {
        let polygonPoints = MapPolygonsModule.currPolygonPoints;
        if (!this.showPoints || !this.paintState)
            return '';
        if (this.paintState) {
            const videoLen = this.videoPolygons[this.index].vertices.length;
            if (polygonPoints === videoLen - 1)
                return 'mouse-bg-finish';
            return `mouse-bg-${polygonPoints + 1}`;
        }
        else {
            return '';
        }
    }
};
__decorate([
    Prop()
], MapDarwer.prototype, "zoneId", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "dataSource", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "buttons", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "showSelect", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "limits", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "isPlayFlag", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "directionConfig", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "specifiedStyle", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "paintState", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "options", void 0);
__decorate([
    Prop({ type: Object,
        default: () => {
            return {
                width: 738,
                height: 415
            };
        } })
], MapDarwer.prototype, "styleProp", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "index", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "videoPolygons", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "mapId", void 0);
__decorate([
    Prop()
], MapDarwer.prototype, "showPoints", void 0);
__decorate([
    Watch('removeKey')
], MapDarwer.prototype, "onchangeKey", null);
__decorate([
    Watch('mapSource', { immediate: true, deep: true })
], MapDarwer.prototype, "onChangeMapSource", null);
__decorate([
    Watch('zoneId', { immediate: true })
], MapDarwer.prototype, "onChangeZoneId", null);
MapDarwer = __decorate([
    Component({
        name: 'MapDarwer',
        components: {
            'st-drawer': Drawer,
            'st-map': map,
            'st-map-util': mapUtil
        },
        i18n: {
            messages: {
                en: {
                    mapRoiError: 'The number of sides of the ROI on the map must be the same as that of the corresponding ROI in the video',
                },
                zh: {
                    mapRoiError: '地图上ROI的边数必须和视频中对应ROI的边数相同',
                }
            }
        }
    })
], MapDarwer);
export default MapDarwer;
